import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFetchCoach } from "../../hooks/useFetchCoach";
import { initMetaPixel, metaPixelInfo, trackPixel } from "../../lib/metaPixel";

const MetaTracker = () => {
    const location = useLocation();
    const { currentCoach } = useFetchCoach();

    useEffect(() => {
        initMetaPixel(
            currentCoach
                ? {
                      email: currentCoach.email,
                      phone: currentCoach.phoneNumber,
                      externalId: currentCoach.id,
                  }
                : undefined
        );
    }, [currentCoach?.email, currentCoach?.id, currentCoach?.phoneNumber]);

    useEffect(() => {
        metaPixelInfo("[Meta Pixel] route PageView trigger", {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
        });
        trackPixel("PageView");
    }, [location.pathname, location.search, location.hash]);

    return null;
};

export default MetaTracker;
